// import { Alert } from '@/app/components/Alert';
import { MessageBox } from '@/app/components/MessageBox';
import cx from 'classnames';
import React from 'react';

import style from './DisableEnquiryMessageBox.module.scss';

export default function DisableEnquiryMessageBox({ className }: { className?: string }) {
  return (
    <MessageBox
      className={cx(style.messageBox, className)}
      showButton={false}
      messageText="Website Under Maintenance: Please note job enquiries and enquiry management are temporarily unavailable. Maintenance is due to end midday on Monday, March 10th."
    />
  );
}
